import styled from 'styled-components';

const ghostDisabledArrows = `
    .ant-btn-background-ghost[disabled],
    .ant-btn-background-ghost[disabled]:hover {
        border-color: transparent !important;
        background: transparent !important;
        opacity: 0.35;
        box-shadow: none;
    }
`;

export const ArticleBlockRoot = styled.div`
    border: ${(props) => props.theme.DefaultBorder};
    background: #fff;
    min-width: 0;
    padding: 0;
    transition: box-shadow 0.2s ease;

    &.is-dragging {
        box-shadow: 0 12px 30px rgba(0, 0, 0, 0.08);
    }
`;

export const ArticleBlockHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.75rem;
    padding: 0.3rem 0.5rem 0.3rem 0.75rem;
    border-bottom: ${(props) => props.theme.DefaultBorder};
`;

export const ArticleBlockTitleGroup = styled.div`
    display: flex;
    align-items: center;
    gap: 0.35rem;
    min-width: 0;
`;

export const ArticleBlockDragHandle = styled.button`
    appearance: none;
    border: 0;
    background: transparent;
    color: ${(props) => props.theme.TextColorMuted};
    cursor: grab;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0.15rem;

    &:active {
        cursor: grabbing;
    }
`;

export const ArticleBlockTypeLabel = styled.span`
    font-size: ${(props) => props.theme.FontSizeSm};
    color: ${(props) => props.theme.TextColorMuted};
    text-transform: uppercase;
    font-weight: 400;
`;

export const ArticleBlockActions = styled.div`
    display: flex;
    align-items: center;
    gap: 0.25rem;

    ${ghostDisabledArrows}
`;

export const ArticleBlockBody = styled.div`
    padding: 0.75rem;
`;

export const QuillEditorWrap = styled.div`
    .ql-toolbar {
        border-color: #d9d9d9;
        border-radius: 4px 4px 0 0;
    }

    .ql-container {
        border-color: #d9d9d9;
        border-radius: 0 0 4px 4px;
        font-family: inherit;
        min-height: ${(props) => (props.$isTitleEditor ? '5rem' : '130px')};
    }

    .ql-editor {
        font-size: 0.9rem;
        line-height: 1.45;
        min-height: ${(props) => (props.$isTitleEditor ? '5rem' : '130px')};
    }

    .ql-editor h1 {
        font-size: 2rem;
        line-height: 1.2;
    }

    .ql-editor h2 {
        font-size: 1.5rem;
        line-height: 1.25;
    }

    .ql-editor.ql-blank::before {
        color: ${(props) => props.theme.TextColorMuted};
        font-style: normal;
    }
`;
